<mat-sidenav-container>
	<mat-sidenav #sidenav mode="side" position="end" opened="false">
		<app-contact-sneak-peek [contact]="selectedRow" (closeRequested)="closeSidenav()"></app-contact-sneak-peek>
	</mat-sidenav>

	<mat-sidenav-content>
		<app-generic-grid
			[selection]="'single'"
			[filters]="filters"
			[pageName]="pageName"
			[allowAdding]="true"
			[selectedRowKeys]="selectedRow ? [selectedRow.id] : []"
			[toolbarActions]="toolbarActions"
			[dataSource]="dataSource"
			[columns]="columns"
			(addAction)="addContact()"
			(rowDblClick)="onRowDblClick($event)"
			(selectionChanged)="onSelectionChanged($event)"
		>
		</app-generic-grid>
	</mat-sidenav-content>
</mat-sidenav-container>
